import React, { useState } from 'react';
import { Users, UserPlus, CalendarCheck, Award, FileText, Plus } from 'lucide-react';

const HRDepartmentPage = () => {
  const [activeTab, setActiveTab] = useState('employees');

  const employees = [
    { id: 1, name: "Thabo Nkosi", position: "Software Engineer", department: "IT", status: "Active" },
    { id: 2, name: "Zinhle Mthethwa", position: "Marketing Manager", department: "Marketing", status: "Active" },
    { id: 3, name: "Sipho Khumalo", position: "Accountant", department: "Finance", status: "On Leave" },
  ];

  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="flex items-center gap-4 mb-8">
        <div className="w-16 h-16 bg-pink-100 rounded-2xl flex items-center justify-center">
          <Users size={40} className="text-pink-600" />
        </div>
        <div>
          <h1 className="text-4xl font-bold text-gray-900">HR Department</h1>
          <p className="text-gray-600">People • Culture • Operations</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex border-b mb-8 bg-white rounded-t-2xl">
        {[
          { id: 'employees', label: 'Employees', icon: Users },
          { id: 'leave', label: 'Leave Management', icon: CalendarCheck },
          { id: 'recruitment', label: 'Recruitment', icon: UserPlus },
          { id: 'performance', label: 'Performance', icon: Award },
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 flex items-center justify-center gap-2 px-6 py-4 font-medium border-b-4 transition-all ${
              activeTab === tab.id 
                ? 'border-custom-orange text-custom-orange' 
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            <tab.icon size={20} />
            {tab.label}
          </button>
        ))}
      </div>

      {/* Employees Tab */}
      {activeTab === 'employees' && (
        <div className="bg-white rounded-3xl shadow p-8">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-semibold">Employee Directory</h2>
            <button className="bg-custom-orange text-white px-6 py-3 rounded-xl flex items-center gap-2 hover:bg-orange-600">
              <Plus size={20} /> Add Employee
            </button>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b">
                  <th className="text-left py-4 px-6 font-medium">Employee</th>
                  <th className="text-left py-4 px-6 font-medium">Position</th>
                  <th className="text-left py-4 px-6 font-medium">Department</th>
                  <th className="text-left py-4 px-6 font-medium">Status</th>
                  <th className="w-32"></th>
                </tr>
              </thead>
              <tbody>
                {employees.map(emp => (
                  <tr key={emp.id} className="border-b hover:bg-gray-50">
                    <td className="py-5 px-6 font-medium">{emp.name}</td>
                    <td className="py-5 px-6 text-gray-600">{emp.position}</td>
                    <td className="py-5 px-6 text-gray-600">{emp.department}</td>
                    <td className="py-5 px-6">
                      <span className={`px-4 py-1 rounded-full text-xs font-medium ${
                        emp.status === 'Active' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'
                      }`}>
                        {emp.status}
                      </span>
                    </td>
                    <td className="py-5 px-6">
                      <button className="text-custom-orange hover:underline text-sm">View Profile</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Leave Management Tab */}
      {activeTab === 'leave' && (
        <div className="bg-white rounded-3xl shadow p-8">
          <h2 className="text-2xl font-semibold mb-6">Leave Management</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 p-8 rounded-2xl text-center">
              <CalendarCheck size={48} className="mx-auto text-pink-600 mb-4" />
              <h3 className="font-semibold text-xl">Annual Leave</h3>
              <p className="text-4xl font-bold text-pink-600 mt-2">18</p>
              <p className="text-sm text-gray-500">Days Remaining</p>
            </div>
            <div className="bg-white border rounded-2xl p-8 text-center">
              <h3 className="font-semibold mb-4">Recent Leave Requests</h3>
              <p className="text-gray-500 text-sm">No pending requests</p>
            </div>
            <div className="bg-white border rounded-2xl p-8 text-center">
              <button className="w-full bg-custom-orange hover:bg-orange-600 text-white py-4 rounded-xl font-medium">
                Request Leave
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Recruitment Tab */}
      {activeTab === 'recruitment' && (
        <div className="bg-white rounded-3xl shadow p-10 text-center">
          <UserPlus size={80} className="mx-auto text-purple-400 mb-6" />
          <h2 className="text-3xl font-semibold mb-4">Recruitment Pipeline</h2>
          <p className="text-gray-600 max-w-md mx-auto">Job postings, candidate tracking, and interview scheduling coming soon.</p>
        </div>
      )}

      {/* Performance Tab */}
      {activeTab === 'performance' && (
        <div className="bg-white rounded-3xl shadow p-10 text-center">
          <Award size={80} className="mx-auto text-amber-500 mb-6" />
          <h2 className="text-3xl font-semibold mb-4">Performance Management</h2>
          <p className="text-gray-600">Reviews, goals, and feedback system under development.</p>
        </div>
      )}
    </div>
  );
};

export default HRDepartmentPage;